import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { getSignal } from 'selectors/feature/inputs'
import { useSelector } from 'hooks/redux'

import { Tooltip } from 'components/patterns'
import InputValueEditor from 'components/feature/NavigatorPanes/editors/base/InputValueEditor/InputValueEditor'

import {
  InputRow,
  StyledIcon,
  ConditionRow,
  MarginRightIcon,
} from './ConditionSimulator.styles'

const ConditionSimulatorInput = ({
  inputConfig,
  translations,
  dataType,
  translationType,
  maxValue,
  minValue,
  units,
  simulatedValue,
  handleUpdateSimulatedValue,
  canReset,
  resetSimulatedValue,
  disableFalseValue,
  signal,
}) => {
  const { translation: { definedSnaValues, definedErrorValues } = {} } =
    useSelector(getSignal, { signal }) || {}

  return (
    <>
      <ConditionRow>
        <MarginRightIcon icon="simulate" />
        <span>{strings.simulated_value_title}</span>
      </ConditionRow>
      <InputRow>
        <InputValueEditor
          inputConfig={inputConfig}
          translations={translations}
          dataType={dataType}
          translationType={translationType}
          maxValue={maxValue}
          minValue={minValue}
          units={units}
          value={simulatedValue}
          onInputValueChange={handleUpdateSimulatedValue}
          narrow
          noLabel
          disableFalseValue={disableFalseValue}
          definedSnaValues={definedSnaValues}
          definedErrorValues={definedErrorValues}
        />
        {canReset && (
          <Tooltip title={strings.reset_to_evaluation}>
            <StyledIcon icon="refresh" onClick={resetSimulatedValue} />
          </Tooltip>
        )}
      </InputRow>
    </>
  )
}

ConditionSimulatorInput.propTypes = {
  inputConfig: PropTypes.string,
  translations: PropTypes.array,
  dataType: PropTypes.string,
  translationType: PropTypes.string,
  maxValue: PropTypes.any,
  minValue: PropTypes.any,
  units: PropTypes.string,
  simulatedValue: PropTypes.any,
  handleUpdateSimulatedValue: PropTypes.func,
  canReset: PropTypes.bool,
  resetSimulatedValue: PropTypes.func,
  disableFalseValue: PropTypes.bool,
  signal: PropTypes.string,
}

export default ConditionSimulatorInput
